import { CarWizardState } from "src/stores/wizard/state";
import { IntentMediaPropsCars } from "src/components/utility/Ads/IntentMedia/mappers/typings";

export function mapCarWizardState(state: CarWizardState): IntentMediaPropsCars {
  return {
    page_id: "homepage.cars",
    trigger_exit_unit: "N"
  };
}
